import baseConfigs from './base';

export default {
  ...baseConfigs,
  paypalClientId: 'AaGRPAKmMBgHMGo2LDNwenUgLX7qjc0qNoXibl80zflmNhOaH1EEmJU7A5BuWvXgPOaymM0s3Nk4W6ad',
  pusherKey: 'ccd57d3fe67f0f316a8c',
  pusherCluster: 'ap1',
  apiUrl: 'https://app.openstudio.cz/api',
};
